<script lang="ts">
	import { fade } from 'svelte/transition';
	import { appStore } from '../../../../../stores/appStore';
	import { getContext } from 'svelte';

	export let href: string;
	export let title: string = '';
	export let text: string;

	const websiteLogin = `${location.origin}/login`;
	const messageId: string = getContext('messageId');
	let target: string;
	let animated: boolean;

	$: animated = $appStore.animatedMessageIds.includes(messageId);
	$: target = href === websiteLogin ? '' : '_blank';
</script>

<a title={title || text} {href} {target}>
	{#if (title || text)?.length === 1}
		<span class="link-wrapper" in:fade|global={{delay: animated ? 180 : 0, duration: animated ? 1000 : 0}}>
			<span class="link">{text}</span>
		</span>
	{:else}
		<span in:fade|global={{delay: animated ? 180 : 0, duration: animated ? 1000 : 0}}>{text}</span>
	{/if}
</a>

<style lang='scss'>
	a {
		color: #3b76ff;
		text-decoration: none;

		@media (hover: hover) {
			&:hover {
				text-decoration: underline;
			}
		}
		.link-wrapper {
			margin: 0 2px 0 4px;
			display: inline-flex;
			width: 1.1rem;
			height: 1.1rem;
			background: var(--link-background);
			color: var(--link-text-color);
			border-radius: 50%;
			.link {
				display: flex;
				align-items: center;
				justify-content: center;
				width: 100%;
			}
		}
	}
</style>